import DocPage from '../components/DocPage.jsx'
import { commands, docsWatch, featureCommandItems } from '../content.js'

// /docs/watch — P6-302. The sixth feature page, and the last of the watch
// spec's own §7 promise ("a docs-watch page ships with the feature") that
// nobody shipped: two later briefs (P6-265/270, V2-1b) assumed this page
// already existed and their lanes correctly reported that it did not.
//
// Four lines for the page itself, like every sibling — content-src/docs-
// watch.json carries the prose, this component only wires it to the shared
// page type (see DocsMovieNight.jsx for why that is the whole return on
// components/DocPage.jsx) — PLUS one generated piece DR2 asks every feature
// page to carry: "its commands (generated, §3)."
//
// 🔴 THAT THIRD PIECE IS GENERATED HERE, NOT IN content-src/docs-watch.json,
// AND NOT BY site/scripts/generate-content.mjs. docs-music.json (#445, the
// template this page follows) never built one — it leaves every /command
// woven into its own prose, checked by the two prose gates but never listed
// as its own block. The brief for this page asks for more: a literal
// generated command list, provably regenerated with zero edits to this
// page's own JSON when the catalog changes. Doing that inside
// generate-content.mjs would mean teaching the SHARED generator a per-page
// feature filter — every sibling page would have to opt out of a shape only a
// few pages use. Doing it here instead costs one call and touches no file
// another page's tests depend on.
//
// The filter is content.js's `featureCommandItems`, and since P6-312 it is
// shared with DocsCards.jsx: until then each page carried its own four-line
// copy (`watchCommandItems` here, `cardsCommandItems` there). It takes the
// catalog as an argument rather than reading `commands.commands` itself — the
// same "inject the input" shape `site/src/portal/branches.js::branchesFor`
// already uses for the identical reason: a test can drive it with a synthetic
// catalog row that is not in the real one, which is the only way to prove this
// list is actually generated rather than a hand-typed one sitting next to a
// comment that claims otherwise. See src/test/documentation.test.jsx.
const doc = {
  ...docsWatch,
  sections: docsWatch.sections.map((section) =>
    section.id === 'commands'
      ? { ...section, items: featureCommandItems(commands.commands, 'watch') }
      : section,
  ),
}

export default function DocsWatch() {
  return <DocPage doc={doc} />
}
